export function formatToBRL(val) {
    if (val === null || val === undefined) return 'R$ 0,00';
  
    let num = 0;
  
    if (typeof val === 'number') {
      num = val;
    } else if (typeof val === 'string' && val.match(/[\.,]/)) {
      num = parseFloat(val.replace(',', '.'));
    } else {
      const strVal = String(val).replace(/\D/g, '');
      num = Number(strVal) / 100;
    }
  
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }